// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#cesiumContainer {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#igcFileDisplay {
  width: 100%;
  height: 100%;
}

.logo-container {
  width: 180px;
  height: 50px;
  position: absolute;
  z-index: 1;
  background-size: cover;
  top: 5%;
  left: 1%;
  opacity: 0.8;
}

@media (max-width: 767px) { /* or any other breakpoint for mobile */
  .logo-container {
    width: 140px;
    height: 40px;
  }
}
@media screen and (max-width: 700px), screen and (max-height: 420px) {
  .navigation-controls {
    display: block !important;
  }
  .compass {
    display: block !important;
  }
}
.distance-legend {
  bottom: 60px !important;
  right: calc(50% - 65px);
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

.cesium-credit-logoContainer:hover {
  cursor: pointer;
}

.cesium-credit-logoContainer div a {
  display: none;
}

.cesium-credit-textContainer div a {
  display: none;
}

.cesium-credit-textContainer a,
.cesium-credit-expand-link {
  display: none !important;
}

.cesium-viewer-fullscreenContainer {
  display: none !important;
}

.cesium-infoBox {
  max-width: 600px;
}

.cesium-viewer-toolbar {
  top: 2%;
  right: 2%;
}

/* Hide Base Layer Picker */
.cesium-viewer-toolbar > button {
  top: 5% !important;
}

.disabled {
  pointer-events: none;
  /* Disable all mouse events */
  opacity: 0.5;
  /* Make it look visually disabled */
  color: #e0e0e0;
}

.no-select-item {
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}`, "",{"version":3,"sources":["webpack://./src/satmon/modules/3dViewer/3dMain.scss"],"names":[],"mappings":"AAAA;;;EAGE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA;EACA,sBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA,4BAAA,uCAAA;EACE;IACI,YAAA;IACA,YAAA;EAAJ;AACF;AAGA;EAEE;IACE,yBAAA;EAFF;EAKA;IACE,yBAAA;EAHF;AACF;AAOA;EACE,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;;EAEE,wBAAA;AALF;;AAQA;EACE,wBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAYA;EACE,OAAA;EACA,SAAA;AATF;;AAWA,2BAAA;AACA;EACE,kBAAA;AARF;;AAYA;EACE,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,mCAAA;EACA,cAAA;AATF;;AAoBA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AAjBF","sourcesContent":["html,\nbody,\n#cesiumContainer {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n#igcFileDisplay {\n  width: 100%;\n  height: 100%;\n}\n\n.logo-container {\n  width: 180px;\n  height: 50px;\n  position: absolute;\n  // left: 20px;\n  z-index: 1;\n  background-size: cover;\n  top: 5%;\n  left: 1%;\n  opacity: 0.8;\n}\n\n@media (max-width: 767px) { /* or any other breakpoint for mobile */\n  .logo-container {\n      width: 140px;\n      height: 40px;\n  }\n}\n\n@media screen and (max-width: 700px),\nscreen and (max-height: 420px) {\n  .navigation-controls {\n    display: block !important;\n  }\n\n  .compass {\n    display: block !important;\n  }\n}\n\n\n.distance-legend {\n  bottom: 60px !important;\n  right: calc(50% - 65px);\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}\n\n.cesium-credit-logoContainer:hover {\n  cursor: pointer;\n}\n\n.cesium-credit-logoContainer div a {\n  display: none;\n}\n\n.cesium-credit-textContainer div a {\n  display: none;\n}\n\n.cesium-credit-textContainer a,\n.cesium-credit-expand-link {\n  display: none !important;\n}\n\n.cesium-viewer-fullscreenContainer {\n  display: none !important;\n}\n\n.cesium-infoBox {\n  max-width: 600px;\n}\n\n// .cesium-infoBox-camera {\n//   display: none !important;\n// }\n\n.cesium-viewer-toolbar {\n  top: 2%;\n  right: 2%;\n}\n/* Hide Base Layer Picker */\n.cesium-viewer-toolbar>button {\n  top: 5% !important;\n  // display: none !important;\n}\n\n.disabled {\n  pointer-events: none;\n  /* Disable all mouse events */\n  opacity: 0.5;\n  /* Make it look visually disabled */\n  color: #e0e0e0;\n}\n\n// .compass {\n//   top: 40px !important;\n// }\n\n// .navigation-controls {\n//   top: 145px !important;\n// }\n\n.no-select-item {\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
